import React from 'react'
import useSessionStatusData from '../../hooks/useSessionStatusData'

import ScrollableTable from '../common/ScrollableTable'
import CloningStatusLabel from '../status/CloningStatusLabel'
import ClonedLeagueLink from './ClonedLeagueLink'
import { JobStatusEnum } from '../../constants'

const headers = [ 'Event/League Name', 'Status' ]

const transformJobsData = (polledJobsList) => {
  if (!polledJobsList) {
    return []
  }

  return polledJobsList.map((job, index) => [
    <ClonedLeagueLink
      key={index}
      label={job?.parameters?.league_name}
      path={job?.job?.status === JobStatusEnum.COMPLETED ? job?.league_path : null}
    />,
    <CloningStatusLabel key={index} status={job?.job?.status} />,
  ])
}

const SessionStatusTable = () => {
  const { polledJobsList } = useSessionStatusData()

  return <ScrollableTable headers={headers} data={transformJobsData(polledJobsList)} withIndex/>
}

export default SessionStatusTable
